import React, { useEffect, useMemo, useState } from "react";
import { api } from "@/lib/api";
import { Link } from "react-router-dom";

export default function Albums() {
  const [songs, setSongs] = useState([]);
  useEffect(() => { api.get("/songs", { params: { limit: 100 } }).then((r) => setSongs(r.data)); }, []);

  const albums = useMemo(() => {
    const m = new Map();
    songs.forEach((s) => {
      if (!s.album) return;
      const a = m.get(s.album) || { name: s.album, cover: s.cover_url, tracks: [] };
      a.tracks.push(s);
      m.set(s.album, a);
    });
    return Array.from(m.values());
  }, [songs]);

  return (
    <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16">
      <div className="mb-12">
        <p className="eyebrow mb-3">The collections</p>
        <h1 className="font-display text-5xl md:text-6xl tracking-tight font-light">Albums.</h1>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
        {albums.map((a, i) => (
          <div key={a.name} data-testid={`album-${a.name}`} className="fade-up" style={{ animationDelay: `${i*80}ms` }}>
            <div className="art-frame rounded-2xl overflow-hidden aspect-square bg-neutral-100">
              <img src={a.cover} alt={a.name} className="w-full h-full object-cover" />
            </div>
            <h3 className="font-display text-2xl mt-4">{a.name}</h3>
            <p className="text-xs text-neutral-500 tracking-widest uppercase">{a.tracks.length} tracks</p>
            <ul className="mt-3 space-y-1 text-sm">
              {a.tracks.map((t) => (
                <li key={t.id} className="flex justify-between items-center py-1 border-b border-neutral-100">
                  <Link to={`/songs/${t.id}`} className="hover:text-neutral-900 text-neutral-600">{t.title}</Link>
                  <span className="text-xs text-neutral-400">${t.price_mp3.toFixed(2)}</span>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>
  );
}
